module.exports = __webpack_public_path__ + "static/media/fund_raise.608ccdb3.png";